import React, { ReactElement } from 'react';

import createUrl from 'app/utils/createUrl';
import { ProductsCardState, ProductTypeEnum } from 'features/products';
import { CourseCard, ProgramCard, MasterclassCard } from 'components';
import { CardTags } from 'components/cards/course';

interface ProductsCardProps {
  product: ProductsCardState;
  active?: boolean;
  evolution?: boolean;
  onProgram?: boolean;
  theme?: 'light' | 'dark';
}

// const ProductButton = styled('button')`
//   transition: background 0.2s;
//   background: ${({ theme }) => theme.colors.gray_600};
//   border: 0;
//   position: relative;
//   text-align: left;
//   padding: 10px 20px;
//   margin: 0;
//   font-size: ${({ theme: { fontSizes } }) => fontSizes[3]};
//   font-weight: ${({ theme: { fontWeights } }) => fontWeights.bold};
//   text-transform: uppercase;
//   outline: none;
//   border-bottom-left-radius: 4px;
//   border-bottom-right-radius: 4px;
// `;

// const ProductButtonIcon = styled(ReactIcon)`
//   width: 24px;
//   color: ${({ theme }) => theme.colors.primary_400};
//   position: absolute;
//   top: 50%;
//   right: 20px;
//   transform: translateY(-50%);
// `;

// const ProductDetails = styled(Flex)``;

// const ProductDetailsDescription = styled(Box)`
//   display: none;
// `;

// const ProductCardWrapper = styled(ConditionalLink)`
//   display: flex;
//   flex-grow: 1;
//   background: ${({ theme }) => theme.colors.gray_500} url(${(props: any) => props['data-background']});
//   background-size: cover;
//   background-position: center;
//   min-height: 400px;
//   margin-top: 30px;
//   border-radius: 4px;
//   flex-direction: column;
//   justify-content: flex-end;
//   max-width: 280px;
//   flex-shrink: 0;

//   ${ProductDetails} {
//     background: ${(props: any) => (props['data-variation'] === 'dark' ? props.theme.colors.dark_150 : props.theme.colors.white)};
//   }

//   ${ProductButton} {
//     background: ${(props: any) => (props['data-variation'] === 'dark' ? props.theme.colors.gray_600 : props.theme.colors.gray_100)};
//     color: ${({ theme }) => theme.colors.primary_400};
//     cursor: ${(props: any) => (props['data-allowaccess'] ? 'pointer' : 'inherit')};
//   }

//   ${ProductButtonIcon} {
//     color: ${({ theme }) => theme.colors.primary_400};
//   }

//   &:hover {
//     ${ProductButton} {
//       background: ${(props: any) =>
//         props['data-allowaccess']
//           ? props.theme.colors.primary_400
//           : props['data-variation'] === 'light'
//           ? props.theme.colors.gray_100
//           : props.theme.colors.gray_600};
//       color: ${(props: any) => (props['data-allowaccess'] ? 'white' : props.theme.colors.primary_400)};
//     }

//     ${ProductButtonIcon} {
//       color: ${(props: any) => (props['data-allowaccess'] ? 'white' : props.theme.colors.primary_400)};
//     }

//     ${ProductDetailsDescription} {
//       display: block;
//     }
//   }
// `;

const ProductCard = ({ product, active, evolution, onProgram, theme = 'light' }: ProductsCardProps): ReactElement => {
  // let allowAccess = false;
  // let cardVariation: 'light' | 'dark' = active || product.enrolled ? 'dark' : 'light';

  // if (product.detailedAccess) {
  //   allowAccess = true;
  // }

  // let buttonLabel = product.detailedAccess ? 'Acessar' : 'Em breve';

  // if (product?.enrolled || product?.allowEnrollemnts) {
  //   buttonLabel = evolution ? 'Minha evolução' : 'Acessar';
  // }

  let cardLink = '';
  if (product.productType === ProductTypeEnum.Program) {
    cardLink = createUrl('programDetails', [product.slug]);
  } else if (product.productType === ProductTypeEnum.MasterClass) {
    cardLink = createUrl('masterClassDetails', [product.slug]);
  } else {
    cardLink = createUrl(evolution ? 'productEvolution' : product.productClassUuid ? 'productClassDetails' : 'productDetails', [
      product.slug,
      product.productClassUuid,
    ]);
    // if (onProgram) {
    // } else {
    //   cardLink = createUrl(evolution ? 'productEvolution' : 'productDetails', [product.slug]);
    // }
  }

  let coursesTags: CardTags = [];

  let courseDisabled = false;
  if (!product.detailedAccess) {
    courseDisabled = true;
    coursesTags.push('soon');
  }

  if (product.productType === ProductTypeEnum.Program) {
    return (
      <ProgramCard
        link={cardLink}
        hat={product.hat}
        name={product.name}
        image={`${product.cardImageUrl}`}
        enrolled={product.enrolled}
        theme={theme}
        disabled={courseDisabled}
        tags={coursesTags}
      />
    );
  }

  if (product.productType === ProductTypeEnum.MasterClass) {
    return (
      <MasterclassCard
        link={cardLink}
        hat={product.hat}
        name={product.name}
        image={`${product.cardImageUrl}`}
        enrolled={product.enrolled}
        theme={theme}
        disabled={courseDisabled}
        tags={coursesTags}
      />
    );
  }

  return (
    <CourseCard
      link={cardLink}
      hat={product.hat}
      name={product.name}
      image={`${product.cardImageUrl}`}
      evolution={undefined}
      enrolled={product.enrolled}
      theme={theme}
      disabled={courseDisabled}
      tags={coursesTags}
    />
  );

  // return (
  //   <ProductCardWrapper
  //     data-variation={cardVariation}
  //     data-allowaccess={allowAccess}
  //     data-background={product.cardImageUrl}
  //     to={cardLink}
  //     type={allowAccess ? 'internal' : 'nolink'}
  //     component={Flex}
  //   >
  //     <ProductDetails borderTopLeftRadius={0} borderTopRightRadius={0} flexGrow={0} p={20} flexDirection="column">
  //       <Typography type="type1" color="gray_500" upper>
  //         {product.hat}
  //       </Typography>

  //       <Typography type="type6" color={cardVariation === 'dark' ? 'white' : 'dark_350'} fontWeight="bold" mt={1} lineHeight="1.1">
  //         {product.name}
  //       </Typography>

  //       {Boolean(product.description) && product.description.length && (
  //         <ProductDetailsDescription mt={3}>
  //           <Typography type="type1" color="gray_500" lineHeight="1.3">
  //             {product.description}
  //           </Typography>
  //         </ProductDetailsDescription>
  //       )}
  //     </ProductDetails>

  //     <ProductButton>
  //       {buttonLabel}
  //       <ProductButtonIcon path={allowAccess ? mdiArrowRight : mdiLock} />
  //     </ProductButton>
  //   </ProductCardWrapper>
  // );
};
export default ProductCard;
